export const currencyCode = "JPY";
export const brand = "aigle";
